import { STATUS_CONFIG } from '@/data/mockData';

export function StatusBadge({ status, variant = 'default' }) {
  const config = STATUS_CONFIG[status];
  if (!config) return null;
  const label = variant === 'client' ? config.clientLabel : config.label;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`text-[11px] ${config.textClass}`}
    >
      {label}
    </span>
  );
}
